import angular from "angular";

angular.module('ui-sentinel.calibrations.calibrationControlCenter', [
    'ui-sentinel.maps'
]);
